// extracted by mini-css-extract-plugin
export var circle = "_o-2";
export var icon = "_o-a";
export var iconHighlight = "_o-0";
export var lg = "_o-8";
export var md = "_o-7";
export var outline = "_o-4";
export var sm = "_o-6";
export var square = "_o-1";
export var xl = "_o-9";
export var xs = "_o-5";
export var xxs = "_o-3";